<template>
  <v-app id="inspire">
    <v-navigation-drawer
      :clipped="$vuetify.breakpoint.lgAndUp"
      :mini-variant="mini"
      v-if="isLogged"
      v-model="drawer"
      width="250"
      app
      fixed
      dark
    >
      <v-list>
        <v-list-tile @click.stop="mini = !mini">
          <v-list-tile-content>
            <v-list-tile-title>MENU</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-tooltip bottom>
              <span slot="activator">
                <v-icon v-if="mini">chevron_right</v-icon>
                <v-icon v-else>chevron_left</v-icon>
              </span>
              <span>Toggle Mini Menu</span>
            </v-tooltip>
          </v-list-tile-action>
        </v-list-tile>

        <sections-list />

      </v-list>
    </v-navigation-drawer>

    <v-toolbar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      color="blue darken-3"
      dark
      app
      fixed
    >
      <v-toolbar-title class="ml-0">
        <v-toolbar-side-icon
          @click.stop="drawer = !drawer"
          v-if="isLogged"
        ></v-toolbar-side-icon>
        <span class="">Admin Guardian</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <div v-if="isLogged">
        <!-- <v-btn
          icon
          @click="handleRoute('/')"
        >
          <v-icon>view_quilt</v-icon>
        </v-btn>

        <v-btn
          icon
          @click="handleRoute('/programs')"
        >
          <v-icon>notifications</v-icon>
        </v-btn> -->

        <v-btn
          icon
          @click="handleSignout()"
        >
          <v-icon>exit_to_app</v-icon>
        </v-btn>

        <!-- <v-btn icon large @click="handleRoute('/signin')">
          <v-avatar size=" 32px " tile>
            <img src="logo.svg " alt="Admin">
          </v-avatar>
        </v-btn>-->
      </div>
    </v-toolbar>

    <v-content>
      <v-container
        fluid
        fill-height
        align-start
      >
        <v-layout justify-center>
          <v-snackbar
            absolute
            bottom
            multi-line
            :color="status.type"
            v-model="status.show"
          >{{ status.message }}</v-snackbar>

          <!-- Route: Page comes here  -->
          <router-view></router-view>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import sectionsList from "@/components/sections-list";
export default {
  components: { sectionsList },
  data: () => ({
    mini: false,
    dialog: false,
    drawer: null,
    showLinks: false
  }),

  computed: {
    status() {
      return this.$store.getters.status;
    },

    isLogged() {
      return this.$store.getters.user ? true : false;
    }
  },

  methods: {
    handleRoute(route) {
      // this.$router.push(route);
    },
    handleSignout() {
      this.$store.dispatch("signout");
      this.$router.push("/signin");
    }
  }
};
</script>
<style>
.outer {
  width: 100%;
}
table.table thead th:not(:first-child),
table.table thead th:first-child,
table.table tbody td:not(:first-child),
table.table tbody td:first-child {
  padding: 0 10px;
}

.no-wrap {
  white-space: nowrap;
}

.name {
  text-transform: capitalize;
}
</style>


// WEBPACK FOOTER //
// src/App.vue